import { Customer } from "@/types/profile";

export type TagType = "static" | "dynamic";

export interface CustomerTagItem {
  id: string;
  name: string;
  type: TagType;
  customerId: string;
  color?: string;
}

// Mock tags per customer (both static and dynamic)
export const mockCustomerTags: CustomerTagItem[] = [
  { id: "t1", name: "Finance Dept", type: "static", customerId: "22222222-2222-2222-2222-222222222222", color: "#10B981" },
  { id: "t2", name: "Exec Machines", type: "static", customerId: "33333333-3333-3333-3333-333333333333", color: "#8B5CF6" },
  { id: "t3", name: "Remote Workers", type: "dynamic", customerId: "11111111-1111-1111-1111-111111111111", color: "#6366F1" },
  { id: "t4", name: "Non-Compliant", type: "dynamic", customerId: "11111111-1111-1111-1111-111111111111", color: "#EF4444" },
  { id: "t5", name: "Developers", type: "static", customerId: "33333333-3333-3333-3333-333333333333", color: "#3B82F6" },
  { id: "t6", name: "High Risk", type: "dynamic", customerId: "44444444-4444-4444-4444-444444444444", color: "#F59E0B" },
];

export const getTagsByCustomerId = (customerId: string): CustomerTagItem[] =>
  mockCustomerTags.filter((t) => t.customerId === customerId);
